import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AppLayout } from './components/layout/AppLayout';
import Landing from './pages/Landing';
import AuthCallback from './pages/AuthCallback';
import Dashboard from './pages/Dashboard';
import ProjectView from './pages/ProjectView';
import DocumentAnalysis from './pages/DocumentAnalysis';
import DocumentGeneration from './pages/DocumentGeneration';
import Timeline from './pages/Timeline';
import Settings from './pages/Settings';
import AdminDashboard from './components/admin/AdminDashboard';
import { RepositoryView } from './components/repository/RepositoryView';
import { Toaster } from 'sonner';
import { ErrorBoundary } from './components/ErrorBoundary';
import { ThemeProvider } from './components/theme/ThemeProvider';
import './styles/themes.css';
import { useState, useEffect } from 'react';
import api from './services/api';

const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const token = localStorage.getItem('auth_token');
  return token ? <>{children}</> : <Navigate to="/" replace />;
};

const AdminRoute = ({ children }: { children: React.ReactNode }) => {
  const token = localStorage.getItem('auth_token');
  const [allowed, setAllowed] = useState<boolean | null>(null);

  useEffect(() => {
    if (!token) { setAllowed(false); return; }
    api.get('/auth/me').then(res => {
      setAllowed(res.data.is_superuser === true);
    }).catch(() => setAllowed(false));
  }, [token]);

  if (!token) return <Navigate to="/" replace />;
  if (allowed === null) return <div className="flex items-center justify-center h-screen"><div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary" /></div>;
  if (!allowed) return <Navigate to="/dashboard" replace />;
  return <>{children}</>;
};

function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider>
        <BrowserRouter>
          <Routes>
            {/* Public routes */}
            <Route path="/" element={<Landing />} />
            <Route path="/auth/callback" element={<AuthCallback />} />
            
            {/* Protected routes */}
            <Route path="/dashboard" element={<ProtectedRoute><AppLayout /></ProtectedRoute>}>
              <Route index element={<Dashboard />} />
            </Route>
            <Route path="/projects/:projectId" element={<ProtectedRoute><AppLayout /></ProtectedRoute>}>
              <Route index element={<ProjectView />} />
              <Route path="analyze" element={<DocumentAnalysis />} />
              <Route path="generate" element={<DocumentGeneration />} />
              <Route path="timeline" element={<Timeline />} />
            </Route>
            <Route path="/repository" element={<ProtectedRoute><AppLayout /></ProtectedRoute>}>
              <Route index element={<RepositoryView />} />
            </Route>
            <Route path="/settings" element={<ProtectedRoute><AppLayout /></ProtectedRoute>}>
              <Route index element={<Settings />} />
            </Route>
            <Route path="/admin" element={<AdminRoute><AppLayout /></AdminRoute>}>
              <Route index element={<AdminDashboard />} />
            </Route>
          </Routes>
          <Toaster position="top-right" />
        </BrowserRouter>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
